// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"73e5066a","458":"3d12c203","764":"1c9e330c","821":"e4aa4da3","943":"d9ca086a"}[chunkId] + ".chunk.css";
};